<template>
	<v-dialog :fullscreen="$vuetify.breakpoint.mobile" width="900px" v-model="dialog" persistent>
		<v-card>
			<v-card-title>
				<v-row>
					<v-col cols="9">
						{{ title || 'Adicionar projeto de lei em' }}
						<span :style="{ color: vademecumCor }">{{ vademecumTitulo }}</span>
					</v-col>
					<v-col cols="3" class="d-flex align-center justify-end">
						<v-btn @click="closeDialog" x-large icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-col>
				</v-row>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col cols="12">
						<v-text-field 
							v-on:keyup.enter="searchProjetoLeis" 
							:disabled="loadingInternalSearch"
							clearable 
							v-model="searchAddProjetoLeis" 
							@click:clear="clearInternalSearch"
							@click:append="searchProjetoLeis"
							:append-icon="loadingSearch ? `mdi-loading` : `mdi-magnify`" 
							:color="dynamicColor"
							hide-details 
							outlined
							placeholder="Pesquise pelo número do PL, palavra da ementa ou autor"
							label="Pesquise pelo número do PL, palavra da ementa ou autor" />
					</v-col>
					<v-col cols="12" md="8">
						<h4>Filtre por esfera</h4>
						<v-btn-toggle v-model="filterEsfera" mandatory :color="dynamicColor" class="ml-3"
							@change="searchProjetoLeis">
							<v-row>
								<v-col cols="6" class="px-0 mx-0" v-for="o in filterOptions" :key="o.value">
									<v-btn class="mx-0 rounded-0" :color="dynamicColor" outlined>{{ o.text }}</v-btn>
								</v-col>
							</v-row>
						</v-btn-toggle>
					</v-col>
					<v-col cols="12" md="4">
						<v-select 
							class="ml-2" 
							v-if="filterEsfera == 1" 
							:items="selectEstadualOptions"
							v-model="selectEstadualSelected" 
							label="Selecione o estado" 
							outlined 
							hide-details
							@change="searchProjetoLeis" 
							:item-color="dynamicColor" 
							:color="dynamicColor" 
							item-text="text"
							item-value="value">
						</v-select>
					</v-col>
				</v-row>
				<v-divider class="my-5"></v-divider>
				<v-list class="mt-3">
					<v-list-item class="px-0 text-center d-flex justify-center"
						v-if="loadingInternalSearch">
						<v-progress-circular indeterminate></v-progress-circular>
					</v-list-item>
					<v-list-item class="px-0 text-center d-flex justify-center"
						v-if="internalProjetoLeisSearch.length === 0 && !loadingInternalSearch">
						<p>Nenhuma legislação encontrada, confira os filtros acima.</p>
					</v-list-item>
					<v-hover v-slot="{ hover }"
						v-for="item in internalProjetoLeisSearch.slice(((currentPage - 1) * itemsPerPage), ((currentPage - 1) * itemsPerPage) + itemsPerPage)"
						:key="item.id">
						<v-list-item :class="hover ? `bkgHover` : ``"
							style="border-top: 1px solid; border-color: v-bind(dynamicColor); border-radius: 10px"
							class="mb-5">
							<v-list-item-content>
								<v-row align="center" class="mb-2" no-gutters>
									<v-col class="pa-0">
										<v-list-item-title>
											<span v-html="highlight(item.numero, searchAddProjetoLeis)"></span>
										</v-list-item-title>
									</v-col>
									<v-col class="pa-0 mt-1">
										<v-chip class="mr-2" :color="dynamicColor" outlined :text-color="dynamicColor"
											style="height: 1.5rem">
											{{ item.esfera }}
										</v-chip>
										<v-chip :color="dynamicColor" outlined :text-color="dynamicColor"
											v-if="item.esfera === `Estadual`" style="height: 1.5rem">
											{{ item.estado }}
										</v-chip>
										<v-chip class="ml-2" :color="dynamicColor" outlined :text-color="dynamicColor"
											v-if="item.esfera === `Municipal`" style="height: 1.5rem">
											{{ item.municipio }}
										</v-chip>
									</v-col>
								</v-row>
								<div>
									<small class="mb-5" v-html="highlight(item.nome, searchAddProjetoLeis)"></small><br>
									Autor {{ item.autor }}
								</div>
							</v-list-item-content>

							<v-list-item-action class="text-center">
								<span 
									class="text-subtitle" 
									style="min-width: 90px; text-transform: uppercase" 
									v-if="isProjetoLeiInVade(item.id)">
									Adicionado
								</span>
								<v-btn 
									v-else 
									small 
									text 
									:color="dynamicColor" 
									:loading="item.loading || false"
									@click="adicionarProjetoLei(item)"
									:disabled="isProjetoLeiInVade(item.id) || item.loading">
									Adicionar
								</v-btn>
							</v-list-item-action>
						</v-list-item>
					</v-hover>
				</v-list>
				<div class="d-flex justify-center mt-4">
					<v-pagination 
						v-if="totalItems > itemsPerPage" 
						v-model="currentPage" 
						:total-visible="5"
						:length="Math.ceil(totalItems / itemsPerPage)" 
						:color="dynamicColor" 
						@input="handlePageChange"
						class="mt-4">
					</v-pagination>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'DialogAddProjetoLei',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		vademecumId: {
			type: [String, Number],
			required: false,
			default: null,
		},
		vademecumTitulo: {
			type: String,
			default: '',
		},
		vademecumCor: {
			type: String,
			default: '#F15A24',
		},
		projetosLeisExistentes: {
			type: Array,
			default: () => [],
		},
		dynamicColor: {
			type: String,
			default: '#F15A24',
		},
		title: {
			type: String,
			default: 'Adicionar projeto de lei em',
		},
	},
	data() {
		return {
			dialog: this.value,
			searchAddProjetoLeis: '',
			loadingInternalSearch: false,
			loadingSearch: false,
			internalProjetoLeisSearch: [],
			filterEsfera: 0,
			selectEstadualSelected: '*',
			currentPage: 1,
			itemsPerPage: 10,
			totalItems: 0,
			filterOptions: [
				{ text: 'Todas', value: 'Todos', disabled: false },
				{ text: 'Estadual', value: 'Estadual', disabled: false },
			],
			selectEstadualOptions: [
				{ text: 'Todos', value: '*' },
				{ text: 'Rio de Janeiro', value: 'RJ' },
			],
			projetosLeisExistentesLocal: [],
		};
	},
	watch: {
		value(newVal) {
			this.dialog = newVal;
			if (newVal) {
				// Quando o dialog é aberto, sincronizar completamente com a prop atualizada
				// Isso garante que projetos de lei excluídos não apareçam como "já adicionados"
				this.projetosLeisExistentesLocal = this.projetosLeisExistentes ? [...this.projetosLeisExistentes] : [];
				
				// Buscar automaticamente ao abrir
				this.searchProjetoLeis();
			} else {
				this.clearInternalSearch();
			}
		},
		dialog(newVal) {
			this.$emit('input', newVal);
		},
		projetosLeisExistentes: {
			handler(newVal) {
				// Se o dialog está aberto, sincronizar com a prop atualizada
				// Isso garante que quando um projeto de lei é excluído, ele seja removido da lista local
				if (this.dialog) {
					const newProjetos = newVal ? [...newVal] : [];
					
					// Criar um mapa dos projetos da prop para busca rápida
					const propProjetosMap = new Map();
					newProjetos.forEach(projeto => {
						const idProjeto = projeto.projetos_leis_id ? projeto.projetos_leis_id.id : projeto.id;
						if (idProjeto) {
							propProjetosMap.set(parseInt(idProjeto), projeto);
						}
					});
					
					// Adicionar apenas projetos que foram adicionados localmente durante esta sessão
					// e que ainda não estão na prop (aguardando confirmação do servidor)
					this.projetosLeisExistentesLocal.forEach(localProjeto => {
						const idProjeto = localProjeto.projetos_leis_id ? localProjeto.projetos_leis_id.id : localProjeto.id;
						if (idProjeto) {
							const jaExiste = propProjetosMap.has(parseInt(idProjeto));
							// Só adicionar se não existe na prop E se foi adicionado nesta sessão (tem id null)
							if (!jaExiste && localProjeto.id === null) {
								newProjetos.push(localProjeto);
							}
						}
					});
					
					this.projetosLeisExistentesLocal = newProjetos;
				} else {
					// Se o dialog está fechado, apenas atualizar quando necessário
					this.projetosLeisExistentesLocal = newVal ? [...newVal] : [];
				}
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		closeDialog() {
			this.dialog = false;
		},
		clearInternalSearch() {
			this.searchAddProjetoLeis = '';
			this.totalItems = 0;
			this.internalProjetoLeisSearch = [];
			this.currentPage = 1;
		},
		highlight(content, query) {
			if (!query) {
				return content;
			}
			return content.replace(new RegExp(query, 'gi'), (match) => {
				return '<span class="my-orange">' + match + '</span>';
			});
		},
		isProjetoLeiInVade(projetoLeiId) {
			if (!this.projetosLeisExistentesLocal || this.projetosLeisExistentesLocal.length === 0) return false;
			return this.projetosLeisExistentesLocal.some(
				(e) => parseInt(e.projetos_leis_id ? e.projetos_leis_id.id : e.id) === parseInt(projetoLeiId)
			);
		},
		handlePageChange() {
			this.searchProjetoLeis();
		},
		async searchProjetoLeis() {
			if (this.searchAddProjetoLeis == null) this.searchAddProjetoLeis = "";

			const searchQuery = this.searchAddProjetoLeis
				? `search:"${this.searchAddProjetoLeis}", `
				: '';

			let filter = 'filter: { esfera: { _nnull: true}, numero: { _nnull: true}}'
			if (this.filterEsfera == 1) {
				filter = `filter: { esfera: {_eq: "${this.filterOptions[this.filterEsfera].value}"} }, `
			}

			if (this.filterEsfera == 1 && this.selectEstadualSelected !== "*") {
				filter = `filter: { esfera: {_eq: "${this.filterOptions[this.filterEsfera].value}"}, estado: { _eq: "${this.selectEstadualSelected}"} }, `
			}

			const query = `
				query FilterByApelidosLeis {
					projetos_leis(${filter}${searchQuery},limit:-1) {
					id
					numero
					data
					nome
					estado
					municipio
					autor
					codigo
					esfera
					ranking
					}
					projetos_leis_aggregated(${filter}${searchQuery}) {
					count { id }
					}
				}
				`;

			this.loadingInternalSearch = true;
			this.internalProjetoLeisSearch = [];
			this.totalItems = 0;

			try {
				const response = await this.$http.post(
					'https://api.mylegis.com.br/graphql',
					{ query }
				);
				const { projetos_leis } = response.data.data;
				this.internalProjetoLeisSearch = projetos_leis.map(v => {
					const item = { ...v, loading: false };
					this.$set(item, 'loading', false);
					return item;
				});
				
				// Ordenar por número (extrair número do formato "123/2024")
				const sortedRows = this.internalProjetoLeisSearch.sort((a, b) => {
					const extractNumber = (numeroString) => {
						const match = numeroString.match(/(\d+)\/\d{4}/);
						return match ? parseInt(match[1]) : 0;
					};
					return extractNumber(b.numero) - extractNumber(a.numero);
				});
				this.internalProjetoLeisSearch = sortedRows;
				this.totalItems = this.internalProjetoLeisSearch.length;
				this.loadingInternalSearch = false;
			} catch (error) {
				this.loadingInternalSearch = false;
				window.console.error('Erro ao buscar projetos de lei:', error);
			}
		},
		async adicionarProjetoLei(projetoLei) {
			// Verificar se o projeto já foi adicionado antes de iniciar
			if (this.isProjetoLeiInVade(projetoLei.id)) {
				return;
			}

			// Verificar se vademecumId está definido
			if (!this.vademecumId) {
				window.console.error('vademecumId não está definido');
				return;
			}

			// Usar $set para garantir reatividade
			this.$set(projetoLei, 'loading', true);
			
			try {
				// Usar o método patch (funciona para vade-mécuns pessoais e de grupo)
				await this.$http.patch('/items/vademecums/' + this.vademecumId, {
					projetos_leis: {
						create: [
							{
								projetos_leis_id: { id: projetoLei.id },
								vademecums_id: this.vademecumId,
							},
						],
					},
				});

				// Adicionar o projeto à lista local de projetos existentes para atualizar a UI imediatamente
				// Isso faz com que o botão mude para "Adicionado" sem precisar recarregar
				if (!this.projetosLeisExistentesLocal.some(e => {
					const idProjeto = e.projetos_leis_id ? e.projetos_leis_id.id : e.id;
					return parseInt(idProjeto) === parseInt(projetoLei.id);
				})) {
					// Adicionar à lista local usando push (reativo)
					this.projetosLeisExistentesLocal.push({
						projetos_leis_id: { id: projetoLei.id },
						id: null // ID da relação será definido quando recarregar
					});
				}
				
				// Emitir evento para o componente pai recarregar os dados
				this.$emit('projeto-lei-adicionado', projetoLei);
				
				this.$set(projetoLei, 'loading', false);
			} catch (error) {
				window.console.error('Erro ao adicionar projeto de lei:', error);
				this.$set(projetoLei, 'loading', false);
			}
		},
	},
};
</script>

<style scoped>
.bkgHover {
	background-color: rgba(241, 90, 36, 0.1);
}
</style>

